(function () {
  'use strict';

  // INDIV-PRICE-CACHE (2026-07-02): Persistenter, pro Kunde namespaced localStorage-
  // Cache für kundenindividuelle B2B-Preise. Ziel: Preise beim Navigieren/Reload
  // SOFORT ohne "Flash of List Price" anzeigen; die Consumer (b2b-card-prices.js,
  // b2b-prices.js, variant-matrix.js) revalidieren IMMER im Hintergrund (Stale-While-
  // Revalidate). Der Helper wird als erstes deferred <script> im <head> geladen, damit
  // window.B2BPriceCache vor allen Consumern definiert ist.
  //
  // Robustheit:
  //  - Nur bei aktivem B2B-Login lesbar (identity() prüft window.b2bConfig.isB2B).
  //  - Ein einziger localStorage-Key pro Kunde: 'b2bpc.v1.<customerId||email>'
  //    → physisch getrennte Buckets, kein Fremdpreis-Leak.
  //  - Value je Bucket: { "<sku>": {p:number, l:'live'|'list', ts:epochMs}, ... }
  //    (keine PII; Identität steckt nur im Key).
  //  - Nur numerische Preise mit level live/list werden persistiert.
  //  - Harte TTL beim Lesen; MAX_ENTRIES-Cap gegen Zumüllung.
  //  - localStorage voll/deaktiviert → available()=false → alle Reads liefern null,
  //    Consumer fallen auf reinen Live-Fetch zurück (= heutiges Verhalten).

  var KEY_PREFIX = 'b2bpc.v1.';
  var TTL_HARD   = 7 * 24 * 60 * 60 * 1000; // 7 Tage: ältere Einträge werden ignoriert
  var MAX_ENTRIES = 2000;                   // Cap pro Kunde gegen unbegrenztes Wachstum

  var _avail = null; // gecachtes Probe-Ergebnis

  function available() {
    if (_avail !== null) return _avail;
    try {
      var k = '__b2bpc_probe__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      _avail = true;
    } catch (e) {
      _avail = false;
    }
    return _avail;
  }

  // Aktuelle Kunden-Identität aus der laufenden Session. Nur bei aktivem B2B.
  function identity() {
    var cfg = window.b2bConfig;
    if (!cfg || !cfg.isB2B) return null;
    if (cfg.customerId !== null && cfg.customerId !== undefined && cfg.customerId !== '') {
      return String(cfg.customerId);
    }
    if (cfg.email) return String(cfg.email).toLowerCase();
    return null;
  }

  function bucketKey() {
    var id = identity();
    return id ? (KEY_PREFIX + id) : null;
  }

  function readBucket() {
    if (!available()) return null;
    var key = bucketKey();
    if (!key) return null;
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return {};
      var obj = JSON.parse(raw);
      return (obj && typeof obj === 'object') ? obj : {};
    } catch (e) {
      return {};
    }
  }

  function writeBucket(key, obj) {
    try {
      localStorage.setItem(key, JSON.stringify(obj));
      return true;
    } catch (e) {
      // Quota o. Ä.: eigenen Bucket leeren und einmal erneut versuchen.
      try {
        localStorage.removeItem(key);
        localStorage.setItem(key, JSON.stringify(obj));
        return true;
      } catch (e2) {
        return false; // still verwerfen — Consumer bleibt funktionsfähig
      }
    }
  }

  function now() { return new Date().getTime(); }

  function get(sku) {
    var bucket = readBucket();
    if (!bucket) return null;
    var e = bucket[sku];
    if (!e || typeof e.p !== 'number') return null;
    if ((now() - (e.ts || 0)) > TTL_HARD) return null;
    return { price: e.p, level: e.l, ts: e.ts };
  }

  function getMany(skus) {
    var out = {};
    var bucket = readBucket();
    if (!bucket) return out;
    var t = now();
    for (var i = 0; i < skus.length; i++) {
      var e = bucket[skus[i]];
      if (e && typeof e.p === 'number' && (t - (e.ts || 0)) <= TTL_HARD) {
        out[skus[i]] = { price: e.p, level: e.l, ts: e.ts };
      }
    }
    return out;
  }

  // Prunt bei Überschreitung des Caps die ältesten Einträge (nach ts).
  function prune(bucket) {
    var keys = Object.keys(bucket);
    if (keys.length <= MAX_ENTRIES) return bucket;
    keys.sort(function (a, b) { return (bucket[a].ts || 0) - (bucket[b].ts || 0); });
    var drop = Math.ceil(keys.length * 0.25);
    for (var i = 0; i < drop; i++) delete bucket[keys[i]];
    return bucket;
  }

  function isPersistableLevel(level) {
    return level === 'live' || level === 'list';
  }

  function set(sku, price, level) {
    if (!available()) return;
    if (!isPersistableLevel(level)) return;
    var p = parseFloat(price);
    if (!isFinite(p)) return;
    var key = bucketKey();
    if (!key) return;
    var bucket = readBucket() || {};
    bucket[sku] = { p: p, l: level, ts: now() };
    writeBucket(key, prune(bucket));
  }

  // map: { sku: price|null }. Nur numerische Preise mit persistierbarem Level werden
  // geschrieben; null/undefined übersprungen (schlanker Bucket).
  function setMany(map, level) {
    if (!available()) return;
    if (!isPersistableLevel(level)) return;
    var key = bucketKey();
    if (!key) return;
    var bucket = readBucket() || {};
    var t = now();
    var wrote = false;
    Object.keys(map).forEach(function (sku) {
      var p = parseFloat(map[sku]);
      if (!isFinite(p)) return;
      bucket[sku] = { p: p, l: level, ts: t };
      wrote = true;
    });
    if (wrote) writeBucket(key, prune(bucket));
  }

  function clear() {
    if (!available()) return;
    var key = bucketKey();
    if (key) { try { localStorage.removeItem(key); } catch (e) {} }
  }

  // Entfernt ALLE Kunden-Buckets (Login-Wechsel / Logout / Session-Ablauf) →
  // verhindert, dass ein Bucket eines vorherigen Nutzers auf demselben Gerät greift.
  function clearAll() {
    if (!available()) return;
    try {
      var toRemove = [];
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf(KEY_PREFIX) === 0) toRemove.push(k);
      }
      toRemove.forEach(function (k) { localStorage.removeItem(k); });
    } catch (e) {}
  }

  window.B2BPriceCache = {
    available: available,
    identity: identity,
    get: get,
    getMany: getMany,
    set: set,
    setMany: setMany,
    clear: clear,
    clearAll: clearAll
  };
})();
